import { render, staticRenderFns } from "./creative-data.vue?vue&type=template&id=b87b4b9e&scoped=true"
import script from "./creative-data.vue?vue&type=script&lang=js"
export * from "./creative-data.vue?vue&type=script&lang=js"
import style0 from "./creative-data.vue?vue&type=style&index=0&id=b87b4b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87b4b9e",
  null
  
)

export default component.exports